(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-soccer/assets/javascripts/league.js') >= 0) return;  svs.modules.push('/components/themes/sport-soccer/assets/javascripts/league.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_soccer = svs.themes.sport_soccer || {};

  svs.themes.sport_soccer.formatTable = function(league) {
    _.each(league, function(team) {
      if (_.isObject(team)) {
        team.position = parseInt(team.position, 10);
      }
    });
    return league;
  };

  svs.themes.sport_soccer.getFormationByPosition = function() {
    return {};
  };

  svs.themes.sport_soccer.isShowHomeAwayTables = function() {
    return true;
  };
})(svs);

 })(window);